import * as yup from 'yup';

export const schema = yup.object({
  per_juros_dia: yup.number().notRequired(),
  qtd_dias_carencia_juros: yup.number().max(31).notRequired(),
  flg_n_calc_juros_fds: yup.boolean().notRequired(),
});
